<script setup lang="ts">
import { t } from '@satch-ui/translations/translations'
import type { Customer } from '@shared/shop-api/customer/types'

import { CustomerXlIcon, CustomerXsIcon } from '@fond-of/satch-icons'
import type { CustomerInterface } from '@fond-of/spryker-api'

export interface CustomerIconProps {
  customer?: CustomerInterface | Customer
}
const props = defineProps<CustomerIconProps>()
</script>

<template>
  <div
    class="relative flex h-[22px] w-[22px] cursor-pointer items-center space-x-1 lg:h-auto lg:w-auto"
  >
    <div>
      <CustomerXlIcon
        class="lg:text-gray-icon hidden w-[1.375rem] text-black lg:block lg:w-3.5"
      />

      <CustomerXsIcon
        class="lg:text-gray-icon w-[1.375rem] text-black lg:hidden lg:w-3.5"
      />
    </div>

    <div
      v-if="customer"
      class="bg-green absolute -top-1 right-0 h-1.5 w-1.5 rounded-full lg:hidden"
    />

    <div class="text-nav text-gray-topnav hidden pt-0.5 lg:block">
      {{
        props.customer?.firstName ||
        props.customer?.email?.split('@')[0] ||
        t('navigation.customer_menu.customerAccount')
      }}
    </div>
  </div>
</template>
